// DATA RECEIVED FROM API

export const afterReceiving = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => afterReceivingOne(object))
  }
  else if (data?.docs && Array.isArray(data.docs)) {
    data.docs = data.docs.map((object: any) => afterReceivingOne(object))
  }
  else if (typeof data === 'object' && data !== null) {
    data = afterReceivingOne(data)
  }
  return data
}

const afterReceivingOne = (object: any) => {
  if (typeof object !== 'object' || !object)
    return object

  return {
    ...object,
    dueAt: object.dueAt ? new Date(object.dueAt) : object.dueAt,
    scheduledAt: object.scheduledAt ? new Date(object.scheduledAt) : object.scheduledAt,
    doneAt: object.doneAt ? new Date(object.doneAt) : object.doneAt,
    _created: object._created ? new Date(object._created) : object._created,
    _updated: object._updated ? new Date(object._updated) : object._updated,
  }
}

export const beforeSending = (data: any) => {
  if (typeof data !== 'object' || !data)
    return data

  const toIso = (value: unknown) => {
    if (value instanceof Date)
      return value.toISOString()
    return value
  }

  return {
    ...data,
    dueAt: toIso(data.dueAt),
    scheduledAt: toIso(data.scheduledAt),
    doneAt: toIso(data.doneAt),
  }
}
